// extracted by mini-css-extract-plugin
module.exports = {"modal":"select-image-preview_modal__1tX7O","content":"select-image-preview_content__3jywU","dialog":"select-image-preview_dialog__2RnYw","img":"select-image-preview_img__3foSh"};